import React, { useState, useEffect } from 'react';
import signinimage from '../asserts/img/logo.png';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { success } from '../slice/userSlice';
import { useNavigate } from 'react-router-dom';
import axiosInstance, { isTokenExpired } from '../apis/axiosConfig';
import './Login.css';

function Login() {
  const [username, setUsername] = useState('admin@gmail.com');
  const [password, setPassword] = useState('admin123');
  const [rememberMe, setRememberMe] = useState(true);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem('token') || sessionStorage.getItem('userToken') || localStorage.getItem('userToken');
    if (token) {
      if (!isTokenExpired(token)) {
        navigate('/dashboard');
      } else {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('userToken');
        sessionStorage.clear();
      }
    }
  }, [navigate]);

  const loginHandler = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password.trim()) {
      toast.error('Please enter email and password.');
      return;
    }

    setLoading(true);
    try {
      const res = await axiosInstance.post('/admin/signin', {
        username: username.trim().toLowerCase(),
        password: password.trim()
      });

      if (res.data && res.data.access_token) {
        const token = res.data.access_token;
        const userName = res.data.name || username;

        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(userName));
        if (rememberMe) {
          localStorage.setItem('userToken', token);
        } else {
          sessionStorage.setItem('userToken', token);
        }

        dispatch(success(res));
        toast.success('Login Successful!');
        navigate('/dashboard');
      } else {
        toast.error(res.data?.message || 'Invalid email or password.');
      }
    } catch (err) {
      console.error('Login error:', err);
      const errMsg = err.response?.data?.message || err.message || 'Invalid email or password.';
      toast.error(errMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleRememberMeChange = (e) => {
    setRememberMe(e.target.checked);
  };

  return (
    <div className="login-wrapper">
      <div className="login-glow"></div>
      
      <div className="login-card">
        <div className="login-logo">
          <img src={signinimage} alt="Aristo Logo" />
        </div>
        
        <h1 className="login-title">Welcome Admin</h1>
        
        <form onSubmit={loginHandler}>
          <div className="login-form-group">
            <input
              type="email"
              className="login-input"
              placeholder="Enter Email Address"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          
          <div className="login-form-group">
            <input
              type="password"
              className="login-input"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          
          <div className="login-checkbox-group">
            <input
              type="checkbox"
              id="rememberMe"
              className="login-checkbox"
              checked={rememberMe}
              onChange={handleRememberMeChange}
            />
            <label htmlFor="rememberMe" className="login-checkbox-label">
              Remember Me
            </label>
          </div>
          
          <button 
            type="submit" 
            className="login-btn" 
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
